<template>
  <footer class="footer">
    <div class="footer-wrapper">
      <!-- <a
        href="https://manyone.com/newsletter"
        target="_blank"
        @click="GA('Footerlink', 'Click', 'Newsletter' )"
      >
        <div class="footer-wrapper-link">
          <p>Newsletter</p>
        </div>
      </a>-->
      <a
        href="https://www.instagram.com/manyone_design/"
        target="_blank"
        @click="GA('Footerlink', 'Click', 'Instagram' )"
      >
        <div class="footer-wrapper-link">
          <p>Instagram</p>
        </div>
      </a>
      <a
        href="https://www.linkedin.com/company/wearemanyone"
        target="_blank"
        @click="GA('Footerlink', 'Click', 'LinkedIn' )"
      >
        <div class="footer-wrapper-link">
          <p>LinkedIn</p>
        </div>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    GA: function(category, action, label) {
      this.$ga.event(category, action, label);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "Footer.scss";
</style>